import type { FunctionType } from "models-webgl2";

export const throttle = <T extends FunctionType>(func: T, ms: number): T => {
  let isThrottled = false;
  let savedArgs: any;
  let savedThis: any;

  function wrapper(this: any) {
    if (isThrottled) {
      savedArgs = arguments;
      savedThis = this as any;
      return;
    }

    func.apply(this, arguments as any);

    isThrottled = true;

    setTimeout(function () {
      isThrottled = false;
      if (savedArgs) {
        wrapper.apply(savedThis, savedArgs);
        savedArgs = savedThis = null;
      }
    }, ms);
  }

  return wrapper as any;
};

export default throttle;
